import { useEffect, useRef, useState } from "react"
import api from '@/services/api/notification-groups'
import { sessionKeys } from "@/config/constants"
import { useNavigate } from "@/lib/router-dom/index"

const useNotifications = () => {
	const { goTo } = useNavigate()

	const isRendered = useRef(false);

	/*
	STATES
	*/
	const [unseenCount, setUnseenCount] = useState(0)
	const [isActive, setIsActive] = useState(false)
	const [notificationArr, setNotificationArr] = useState([])
	const [pivotNotification, setPivotNotification] = useState('')
	const [onlyUnRead, setOnlyUnRead] = useState(false)
	const [loading, setLoading] = useState(false)

	/*
	API CALLS HANDLERS
	*/
	const handleRedirect = (path, notificationId) => {
		markReadNotificationItem(undefined, notificationId)
		goTo(path)
		api.markRead([notificationId])
		setIsActive(false)
	}
	const handlePopup = (state) => {
		setIsActive(() => !state)
	}
	const showUnreadNotifications = async () => {
		setOnlyUnRead((prev) => !prev)
	}

	const initNotifications = async (limit) => {
		const unseenPivotNotificationId = sessionStorage.getItem(sessionKeys.unseenPivotNotificationId);
		setNotificationArr([]);
		if (unseenPivotNotificationId) {
			await getAllNotifications(unseenPivotNotificationId, limit);
		}
	}

	useEffect(async () => {
		if (!isRendered.current) {
			isRendered.current = true;
			return;
		}

		initNotifications();
	}, [onlyUnRead]);

	const getAllUnseenNotificationsCount = async () => {
		const [, response] = await api.getUnseen()
		if (!response) {
			return;
		}
		const { count = 0, pivotNotificationId = "" } = response
		setUnseenCount(count)
		setPivotNotification(pivotNotificationId)
		return count;
	}


	const getAllNotifications = async (pivotNotificationId, limit) => {
		if (pivotNotificationId == null) {
			console.log('Skipping fetching notifications as pivotNotificationId is not provided');
			return;
		}
		setLoading(true)
		const [err, notifications] = await api.getAll(pivotNotificationId, onlyUnRead, limit)
		setLoading(false)
		if (err) {
			return;
		}
		const nextPivotNotificationId = notifications?.length ? notifications[notifications.length - 1].notificationId - 1 : null;
		setPivotNotification(nextPivotNotificationId)
		setNotificationArr((prev) => [...prev, ...notifications])
		return notifications;
	}

	const markNotificationsAsSeen = async (num) => {
		if (num === undefined || num === null || num <= 0) return
		const unseenPivotNotificationId = sessionStorage.getItem(sessionKeys.unseenPivotNotificationId)
		await api.markSeen(unseenPivotNotificationId)
	}

	const markReadNotificationItem = async (e, notificationId) => {
		const updatedArray = notificationArr.map((item => {
			if (item.notificationId === notificationId) {
				const updatedItem = { ...item, read: true }
				return updatedItem
			}
			return item
		}))
		setNotificationArr(updatedArray)
		e?.stopPropagation();
		await api.markRead([notificationId])
	}

	const markReadAllNotifications = async () => {
		setNotificationArr(notificationArr.map((item) => ({ ...item, read: true })))
		await api.markReadAll(notificationArr[0].notificationId)
	}

	return {
		onlyUnRead,
		isActive,
		pivotNotification,
		unseenCount,
		notificationArr,
		loading,
		handlePopup,
		setNotificationArr,
		setIsActive,
		handleRedirect,
		getAllUnseenNotificationsCount,
		getAllNotifications,
		markNotificationsAsSeen,
		markReadNotificationItem,
		markReadAllNotifications,
		showUnreadNotifications,
		initNotifications,
	}
}


export default useNotifications
